var _defs, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo12(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#1c92c7;}.cls-3{fill:#fff;}.cls-4{fill:url(#\u041D\u043E\u0432\u044B\u0439_\u043E\u0431\u0440\u0430\u0437\u0435\u0446_\u0443\u0437\u043E\u0440\u0430_2);}.cls-5{fill:url(#\u041D\u043E\u0432\u044B\u0439_\u043E\u0431\u0440\u0430\u0437\u0435\u0446_\u0443\u0437\u043E\u0440\u0430_2-5);}.cls-6{fill:url(#\u041D\u043E\u0432\u044B\u0439_\u043E\u0431\u0440\u0430\u0437\u0435\u0446_\u0443\u0437\u043E\u0440\u0430_2-7);}.cls-7{fill:url(#\u041D\u043E\u0432\u044B\u0439_\u043E\u0431\u0440\u0430\u0437\u0435\u0446_\u0443\u0437\u043E\u0440\u0430_2-9);}"), /*#__PURE__*/React.createElement("pattern", {
    id: "\\u041D\\u043E\\u0432\\u044B\\u0439_\\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446_\\u0443\\u0437\\u043E\\u0440\\u0430_2",
    "data-name": "\\u041D\\u043E\\u0432\\u044B\\u0439 \\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446 \\u0443\\u0437\\u043E\\u0440\\u0430 2",
    width: 77.08,
    height: 77.08,
    patternTransform: "translate(80.07 52.58) scale(0.81 0.85)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 77.08 77.08"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 77.08,
    height: 77.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 77.08,
    height: 77.08
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "\\u041D\\u043E\\u0432\\u044B\\u0439_\\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446_\\u0443\\u0437\\u043E\\u0440\\u0430_2-5",
    "data-name": "\\u041D\\u043E\\u0432\\u044B\\u0439 \\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446 \\u0443\\u0437\\u043E\\u0440\\u0430 2",
    width: 77.08,
    height: 77.08,
    patternTransform: "translate(-159.21 -8.57) scale(2.02 1.61)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 77.08 77.08"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 77.08,
    height: 77.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 77.08,
    height: 77.08
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "\\u041D\\u043E\\u0432\\u044B\\u0439_\\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446_\\u0443\\u0437\\u043E\\u0440\\u0430_2-7",
    "data-name": "\\u041D\\u043E\\u0432\\u044B\\u0439 \\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446 \\u0443\\u0437\\u043E\\u0440\\u0430 2",
    width: 77.08,
    height: 77.08,
    patternTransform: "translate(-460 -25.82) scale(3.17 1.56)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 77.08 77.08"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 77.08,
    height: 77.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 77.08,
    height: 77.08
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "\\u041D\\u043E\\u0432\\u044B\\u0439_\\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446_\\u0443\\u0437\\u043E\\u0440\\u0430_2-9",
    "data-name": "\\u041D\\u043E\\u0432\\u044B\\u0439 \\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446 \\u0443\\u0437\\u043E\\u0440\\u0430 2",
    width: 77.08,
    height: 77.08,
    patternTransform: "matrix(3.17, 0, 0, -1.56, -460, 149.45)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 77.08 77.08"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 77.08,
    height: 77.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 77.08,
    height: 77.08
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo_12") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_3_\\u043A\\u043E\\u043F\\u0438\\u044F_",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 3 (\\u043A\\u043E\\u043F\\u0438\\u044F)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 80,
    y: 31.92,
    width: 171.04,
    height: 191.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M243,39.92V215.67H88V39.92H243m8-8H80V223.67H251V31.92Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 94,
    y: 45.92,
    width: 143.04,
    height: 163.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M231,51.92V203.67H100V51.92H231m6-6H94V209.67H237V45.92Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_9",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 5,
    y: 67,
    width: 123,
    height: 122
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M123,72V184H10V72H123m5-5H5V189H128V67Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_7",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 29,
    y: 91,
    width: 76,
    height: 25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M99,97v13H35V97H99m6-6H29v25h76V91Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 29,
    y: 140,
    width: 76,
    height: 25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M99,146v13H35V146H99m6-6H29v25h76V140Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo12);
export default __webpack_public_path__ + "static/media/logo_12.93bfd43e3d5e0dbf36c9e01cd47573ed.svg";
export { ForwardRef as ReactComponent };